// extracted by mini-css-extract-plugin
export default {"wrapper":"NCmBROYcMsUmM2yT4d3pAs68DQFyfQY1"};